import React from 'react';
import OurGallery from '../../components/Gallery/Gallery';
import Footer from '../../components/Footer/Footer';
import Hero from '../../components/Hero/Hero';
import OurLocation from '../../components/OurLocation/OurLocation';
import OurServices from '../../components/Services/Services';
import Slider from '../../components/Slider/Slider';
import About from '../../components/About/About';
import OurTeam from '../../components/OurTeam/OurTeam';
import Form from '../../components/Form/Form';
import Navigation from '../../components/Navigations/Navigation';
import PatientCare from '../../components/Services/PatientCare/PatientCare';
import NursingCare from '../../components/Services/NursingCare/NursingCare';
import MotherCare from '../../components/Services/MotherCare/MotherCare';
import ElderlyCare from '../../components/Services/ElderlyCare/ElderlyCare';
import BabyCare from '../../components/Services/BabyCare/BabyCare';
import Physiptherapy from '../../components/Services/Physiptherapy/Physiptherapy';

const HomePage = () => {
  return (
    <div>
      <div>
        <Navigation />
      </div>
      <div>
        {/* <Physiptherapy /> */}
      </div>
      <div>
        
        {/* <BabyCare /> */}
      </div>
      <div>
        {/* <ElderlyCare /> */}
      </div>
      <div>
        {/* <PatientCare /> */}
        </div>

    <div>
      {/* <MotherCare /> */}
    </div>

        <div>
          {/* <NursingCare /> */}
        </div>
      
      <div>
        <Hero />  
      </div>
      <div>
        <Slider />
      </div>
      <div>
        <OurServices />
      </div>
      <div>
        <OurTeam />
      </div>
      <div>
        <About />
      </div>
      <div>
        <OurLocation />
      </div>
      <div>
        <OurGallery />
      </div>
      <div>
        <Form />
      </div>
      <div>
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default HomePage;